<template>
  <Main>
    <QuotationEditForm
      :form="currentQuotationToEdit"
      @submit="submit"
      v-if="show"
      @return="previousPage"
    />
  </Main>
</template>
<script>
import QuotationEditForm from "../components/QuotationEditForm";
import { mapActions, mapState } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    show: false,
    modal: false
  }),
  components: {
    QuotationEditForm
  },
  mixins: [QuotationMixin, LoadingRequest],
  created() {
    this.fetchEditQuotation();
  },
  computed: {
    ...mapState("quotation", ["currentQuotationToEdit"])
  },
  methods: {
    ...mapActions("quotation", [
      "requestEditQuotation",
      "requestCurrentQuotationToEdit"
    ]),
    ...mapActions(["showAlertNotification"]),
    fetchEditQuotation() {
      this.withLoading(
        this.requestCurrentQuotationToEdit(this.$route.params.id)
      );
    },
    async submit(form) {
      this.withLoading(
        this.requestEditQuotation(
          await this.getEditPayload(form, this.$route.params.id)
        ).then(() => {
          this.showAlertNotification({
            message: "Cotação foi editada com sucesso.",
            type: "success"
          });
          this.previousPage();
        })
      );
    },
    previousPage() {
      this.$router.push({
        name: "quotation element",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    currentQuotationToEdit() {
      this.show = true;
    }
  }
};
</script>
